import { createInitialStates, createResourceNames, createSequenceTypes, getErrorData } from '../helpers'
import { INITIAL_STATE_REDUCERS } from '../constants'

const RESOURCES = ['fileTypesGet']
const R = createResourceNames(RESOURCES)
const TYPES = createSequenceTypes(['FILE_TYPES_GET'])
export const INITIAL_STATE = {
  ...createInitialStates(RESOURCES, INITIAL_STATE_REDUCERS)
}

const reducers = {
  // FILE TYPES GET ····························································
  [TYPES.FILE_TYPES_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.fileTypesGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.FILE_TYPES_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = payload.data.data
    return { ...state, [R.fileTypesGet]: { data, error: {}, isLoading: false } }
  },
  [TYPES.FILE_TYPES_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return { ...state, [R.fileTypesGet]: { data: [], error, isLoading: false } }
  },
  [TYPES.FILE_TYPES_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.fileTypesGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  }
}

export default reducers
